import Login from "./Login";
import Register from "./Register";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginResult } from "../State/LoginResultContext";

const LoginRegister = () => {
  const [formType, setFormType] = useState("login");
  const { loginResults } = useLoginResult();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already logged in, redirect to events page
    if (loginResults) {
      navigate("/my-events");
    }
  }, [loginResults, navigate]);

  const switchForm = (type) => {
    setFormType(type);
  };

  // Don't render login/register if user is already logged in
  if (loginResults) {
    return null;
  }

  return (
    <>
      {formType === "register" ? (
        <Register switchForm={switchForm} />
      ) : (
        <Login switchForm={switchForm} />
      )}
    </>
  );
};

export default LoginRegister;
